import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Tabs, Tab, Box } from '@mui/material';
import { X } from 'lucide-react';
import BoardMembersPanel from './BoardMembersPanel';
import BoardTeamsPanel from './BoardTeamsPanel';

interface BoardAccessDialogProps {
  open: boolean;
  onClose: () => void;
  boardId: string;
  workspaceId?: string;
  canManage: boolean;
}

const BoardAccessDialog: React.FC<BoardAccessDialogProps> = ({
  open,
  onClose,
  boardId,
  workspaceId,
  canManage,
}) => {
  const [tab, setTab] = useState(0);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        Project Access
        <IconButton onClick={onClose} size="small">
          <X size={18} />
        </IconButton>
      </DialogTitle>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 3 }}>
        <Tabs value={tab} onChange={(_, v) => setTab(v)}>
          <Tab label="Members" />
          <Tab label="Teams" />
        </Tabs>
      </Box>
      <DialogContent>
        {tab === 0 && (
          <BoardMembersPanel boardId={boardId} workspaceId={workspaceId} canManage={canManage} />
        )}
        {tab === 1 && (
          <BoardTeamsPanel boardId={boardId} workspaceId={workspaceId} canManage={canManage} />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default BoardAccessDialog;
